import * as promoCodesActions from "./actions";
import reducer from "./reducers";

export { promoCodesActions };

export default reducer;
